module.exports = __webpack_public_path__ + "media/images/analytics-nav-icon-dbb64c51c2b873c53ed9dc73e2bea5e5.svg";